import { ReactElement } from 'react';
import { EIconSize } from 'utils/constants/app/ui';
import { SpinCover, SpinWrapper } from './style';
import { ConditionalWrapper } from 'components/ConditionalWrapper';
import { Loading } from 'components/Loading';

type TCenteredSpinProps = {
  cover?: boolean;
  className?: string;
};

const centeredSpinDefaultProps = {
  cover: false
};

export const CenteredSpin = ({
  cover,
  className
}: TCenteredSpinProps = centeredSpinDefaultProps): ReactElement => {
  return (
    <ConditionalWrapper
      condition={!!cover}
      wrapper={children => <SpinCover>{children}</SpinCover>}
    >
      <SpinWrapper>
        <Loading size={EIconSize._48} className={className} />
      </SpinWrapper>
    </ConditionalWrapper>
  );
};
